import _construct from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/construct";
import { unpack, type } from '../../utils/index.js';
import chroma from '../../chroma.js';
import Color from '../../Color.js';
import input from '../input.js';
import lab2rgb from './lab2rgb.js';
import rgb2lab from './rgb2lab.js';
import { getLabWhitePoint, setLabWhitePoint } from './lab-constants.js';
Color.prototype.lab = function () {
  return rgb2lab(this._rgb);
};
var lab = function lab() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return _construct(Color, args.concat(['lab']));
};
Object.assign(chroma, {
  lab: lab,
  getLabWhitePoint: getLabWhitePoint,
  setLabWhitePoint: setLabWhitePoint
});
input.format.lab = lab2rgb;
input.autodetect.push({
  p: 2,
  test: function test() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    args = unpack(args, 'lab');
    if (type(args) === 'array' && args.length === 3) {
      return 'lab';
    }
  }
});
export { lab, getLabWhitePoint, setLabWhitePoint };